import { z } from 'zod';
import { createZodDto } from 'nestjs-zod';

export const measurementReport = z.object({
  value: z.number(),
  unit: z.string(),
  thresholds: z.array(z.number()).length(4),
  colors: z.array(z.string()).length(5),
});

export class MeasurementReport extends createZodDto(measurementReport) {}
